import { useMutation } from "@tanstack/react-query"

import { api } from "@/lib/api-client"
import { queryKeys } from "@/lib/query-keys"

type GetUploadUrlData = {
  videoName: string
}

type GetUploadUrlResponse = {
  message: string
  upload_url: string
}

function getUploadUrl(data: GetUploadUrlData): Promise<GetUploadUrlResponse> {
  return api.get(`/video-insight/get-upload-url?videoName=${data.videoName}`)
}

export function useGetUploadUrl() {
  const getUploadUrlMutation = useMutation({
    mutationKey: queryKeys.uploadUrl,
    mutationFn: getUploadUrl,
  })

  return { getUploadUrlMutation }
}
